export function sanitizeImageUrl(url?: string): string | undefined {
  if (!url || typeof url !== 'string') return undefined;

  // Trim whitespace
  const cleanUrl = url.trim();

  // Reject SVG for security reasons
  const lowerUrl = cleanUrl.toLowerCase();
  if (lowerUrl.includes('image/svg+xml') || lowerUrl.endsWith('.svg') || lowerUrl.includes('.svg?')) {
    return undefined;
  }

  // Allow base64 encoded images
  if (cleanUrl.startsWith('data:image/png;base64,') || 
      cleanUrl.startsWith('data:image/jpeg;base64,') || 
      cleanUrl.startsWith('data:image/webp;base64,')) {
    return cleanUrl;
  }

  // Allow relative URLs (our own server cache proxy)
  if (cleanUrl.startsWith('/') && !cleanUrl.startsWith('//')) {
    return cleanUrl;
  }

  try {
    const parsedUrl = new URL(cleanUrl);
    
    // STRICT RULE: Only allow HTTPS. 
    // This prevents 'javascript:', 'vbscript:', 'data:text/html', 'http:', etc.
    if (parsedUrl.protocol === 'https:') {
      return cleanUrl;
    }
    
    // In local development we might allow http://localhost or http://127.0.0.1
    // but in production it should strictly be https.
    if (parsedUrl.protocol === 'http:' && 
       (parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1')) {
      return cleanUrl;
    }
  } catch (e) {
    // If URL parsing fails, it's not a valid URL
    return undefined;
  }

  return undefined;
}
